<template>
  <div id="kiosk_dealer_wrapper">
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    mounted() {
    },
  }
</script>
